export const DEFAULT_MARKDOWN_CONTENT = `# Getting Started with QwickPDF

Welcome! QwickPDF transforms your markdown into professional PDFs—all in your browser with complete privacy.

## Quick Start

1. **Edit markdown** - Type or paste your content in the left pane
2. **Watch it render** - See live preview as you type
3. **Customize** - Adjust typography and add letterhead branding
4. **Export** - Download as PDF or print directly

## Why QwickPDF?

- **100% Private** - Everything stays in your browser, no uploads
- **Professional** - Customizable typography and letterheads
- **Fast** - Live preview as you type
- **Free** - No accounts, no limits, no tracking

## Need Help with Markdown?

Click the **"Markdown Cheatsheet"** button in the toolbar above to see all supported formatting options.

**Ready?** Start editing this text or clear it to begin fresh!
`;
